<template>
    <div>
        <Card>
            <p slot="title">
                Invoices
            </p>            
            <div>
                <apexchart 
                    :key="componentKey"
                    v-if="dataMarkingInvoicesPercentage.length > 0"
                    type=heatmap 
                    height=1400 
                    :options="chartOptions" 
                    :series="dataMarkingInvoicesPercentage" />

                <apexchart 
                    :key="componentKey"
                    v-if="dataMarkingInvoicesAmount.length > 0"
                    type=heatmap 
                    height=1400 
                    :options="chartOptions" 
                    :series="dataMarkingInvoicesAmount" />

                <Button type="info"
                    @click="setupData"
                >Test
                </Button>

                <!-- <pre>
                    {{  dataMarkingInvoices }}
                </pre> -->
                <hr/>
                <!-- {{  dataMarkingInvoices }} -->

            </div>
        </Card>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
import {HTTP} from '@/components/http-lib'

export default {
    components : { apexchart : VueApexCharts },    
    props: {

    },
    data: () => ({
        chartOptions: {
            chart: {
                id: 'vuechart-example'
            },
            xaxis: {
                categories: []
            },
            dataLabels: {
                enabled: true,
                style: {
                colors: ['#2b2b2b']
                }
            },

            
            componentKey: 0,
            colors: ["#008FFB"],

            title: {
                text: 'Percentage of Marking Increasing Invoice'
            }
        },
        
        _chartOptions: {
          chart: {
            id: 'vuechart-example'
          },
          xaxis: {
            categories: []
          },
          colors: ["#1b8a5a"],          
          stroke: {
            width: 0
          },
          componentKey: 0,
          plotOptions: {
            heatmap: {
              radius: 0,
              enableShades: false,
              colorScale: {
                ranges: [{
                    from: 0,
                    to: 10,
                    name: 'low',
                    color: '#FF404B'
                  },
                  {
                    from: 11,
                    to: 40,
                    name: 'medium',
                    color: '#C1DECB'
                  },
                  {
                    from: 40,
                    to: 60,
                    name: 'high',
                    color: '#84BD97'
                  },
                  {
                    from: 60,
                    to: 80,
                    name: 'extreme',
                    color: '#469C63'
                  },
                  {
                    from: 80,
                    // to: 1000,
                    name: 'extreme',
                    color: 'blue'
                  }                  
                ]
              },
            },     
          }  
        },
        series: [
            {
                name: 'series-1',
                data: [60, 50, 0, 0, 10, 2, 80, 2]
            },
            {
                name: 'series-2',
                data: [0, 1, 2, 8000, 4, 5, 79, 18]
            },
            {
                name: 'series-3',
                data: [30, 40, 45, 81, 49, 60, 70, 91]
            },
            {
                name: 'series-4',
                data: [30, 40, 45, 50, 49, 60, 10, 15]
            },
            {
                name: 'series-6',
                data: [30, 40, 45, 50, 49, 60, 70, 91]
            },
        ],

        dataChart: [],
        dataChartValue : "",
        dataMarkingInvoicesPercentage: [],
        dataMarkingInvoicesAmount: []
    }),  
    methods: {
      setupData: function(){
        this.dataChartValue = _.groupBy(this.dataChart, 'marking')

        this.dataMarkingInvoicesPercentage = []
        this.dataMarkingInvoicesAmount = []
        

        let parent = this
        _.forEach(this.dataChartValue, function(value, key) {

            let periods = parent.chartOptions.xaxis.categories

            let invoicesAmount = []
            let invoicesPercentage = []
            let markingPeriods = []

            _.forEach(value, function(val) {
                markingPeriods.push(val.period)
            }); 

            let periodNulls = _.difference(periods, markingPeriods)

            _.forEach(periodNulls, function(periodNull) {
                let nullPeriod = {
                    period : periodNull,
                    amount : 0
                }
                value.push(nullPeriod)
            }); 

            let sortedValue = _.sortBy(value, [function(o) { return o.period; }]);
            
            let invoiceBiggest = _.maxBy(sortedValue, 'amount');
            let invoiceBiggestAmount = _.floor((invoiceBiggest.amount / 1000000))

            _.forEach(sortedValue, function(val) {
                let amountInBillion =  _.floor((val.amount / 1000000))

                let percentageOfBiggest =  (amountInBillion/invoiceBiggestAmount) * 100
                let percentageOfBiggestRound = _.floor(percentageOfBiggest)

                invoicesAmount.push(amountInBillion)
                invoicesPercentage.push(percentageOfBiggestRound)                
            }); 

            let keyName = key + ' - ' + invoiceBiggestAmount;

            let dataMarkingInvoicePercentage = {
                name : keyName,
                data : invoicesPercentage
            }

            let dataMarkingInvoiceAmount = {
                name : keyName,
                data : invoicesAmount
            }
            
            parent.dataMarkingInvoicesPercentage.push(dataMarkingInvoicePercentage)
            parent.dataMarkingInvoicesAmount.push(dataMarkingInvoiceAmount)
        });
        
        // console.log(this.dataMarkingInvoices);
        this.componentKey += 1;  
      },

      getInvoicesAmountByPeriod: function(year, month, limit) {
        HTTP
            .get('invoicesAmountByPeriod/year/'+year+'/month/'+month+'/limit/'+limit)
            .then(response => {
                this.dataChart = response.data.data.dataChart;
                this.chartOptions.xaxis.categories = response.data.data.periods;                
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })          
      }
    },    

    created() {
        this.getInvoicesAmountByPeriod(2018, 1, 50);
    },

    watch: {
        dataChart: function(val, oldVal) {
            this.setupData();
        }
    }
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// DashboardInvoices.vue?28be3a2e